import { useState } from "react";

import StarEmptyIcon from "../../assets/star_empty.png";
import StarFullIcon from "../../assets/star_full.png";

import "./starTierButtonStyles.css";

const StarTierButton = ({ amountStars, tier, setTier }) => {
  const [hover, setHover] = useState(0);

  return (
    <div className="star-tier text-center">
      {[...Array(amountStars)].map((star, index) => {
        index += 1;
        return (
          <button
            type="button"
            key={index}
            className="button-star"
            onClick={() => setTier(index)}
            onMouseEnter={() => setHover(index)}
            onMouseLeave={() => setHover(tier)}
          >
            <img
              src={index <= (hover || tier) ? StarFullIcon : StarEmptyIcon}
              alt="star"
            />
          </button>
        );
      })}
    </div>
  );
};

export default StarTierButton;
